import React from 'react';
import _ from 'lodash';
import { Button, Box, Checkbox, Stack, Typography, List } from '@mui/material';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { useMutation, useParameterizedQuery, useQuery } from 'react-fetching-library';
import { DebounceInput } from 'react-debounce-input';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import { getTransportsSeatsControlAvailableCamps, getTransportsSeatsControlAvailableTransports, submitTransportsSeatsControlAction } from '../../../../../services/request';
import { SmallFormTextField } from '../../../../../components/small-fields/SmallFormTextField';
import { AlertDialogContainer } from '../../../../../components/others/AlertDialogContainer';
import { ConfirmDialog } from '../../../../../components/ConfirmDialog';

const validationSchema = Yup.object({
  name: Yup.string().required('To pole nie może być puste'),
  type: Yup.string().required('To pole nie może być puste'),
  seats: Yup.number().required('To pole nie może być puste')
  // camp: Yup.string().required('To pole nie może być puste')
});

export function TransportSeatsForm({ data, submitCallback, handleClose, allResorts }) {

  const { loading, mutate } = useMutation(submitTransportsSeatsControlAction);
  const initialValues = {
    name: data ? data.name || '' : '',
    type: data ? data.type || null : null,
    camp: data ? data.camp || null : null,
    transports: data ? data.transports || [] : [],
    seats: data ? data.seats || 0 : 0,
    resort: data ? data.resort || null : null
  };
  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema,
    onSubmit: values => {
      handleSubmit(values);
    }
  });
  const { loading: availableCampsLoading, payload: availableCampsPayload, error: availableCampsError } = useQuery(getTransportsSeatsControlAvailableCamps(formik.values.type));
  const { loading: availableTransportsLoading, payload: availableTransportsPayload, error: availableTransportsError } = useQuery(getTransportsSeatsControlAvailableTransports(formik.values.camp, formik.values.type, data ? data.id : undefined));
  const [showAlert, setShowAlert] = React.useState(false);
  const [severity, setSeverity] = React.useState('');
  const [title, setTitle] = React.useState('');
  const [message, setMessage] = React.useState('');
  const [confirmDeleteOpen, setConfirmDeleteOpen] = React.useState(false);

  const handleSubmit = async values => {
    const { error, payload } = await mutate(values, data ? 'PUT' : 'POST', data ? data.id : undefined);
    if (!error) {
      submitCallback(payload, data ? 'edit' : 'created', 'success', data ? 'Zaktualizowano transport' : 'Dodano nowy transport', '');
      handleClose();
    } else {
      setSeverity('error');
      setTitle('Nie udało się dodać nowego transportu');
      setMessage('');
      setShowAlert(true);
    }
  };

  const handleDelete = async () => {
    const { error, payload } = await mutate([], 'DELETE', data.id);
    if (!error) {
      submitCallback(data, 'delete', 'success', `Usunięto transport ${data.name}`, '');
      handleClose();
    } else {
      setSeverity('error');
      setTitle(`Nie udało się usunąć transportu ${data.name}`);
      setMessage(payload);
      setShowAlert(true);
    }
  };


  return <>
    {showAlert && (
      <AlertDialogContainer
        severity={severity}
        title={title}
        message={message}
        setShowAlert={setShowAlert}
      />
    )}
    <form style={{ textAlign: 'center' }} onSubmit={formik.handleSubmit}>
      <Stack direction="row" alignItems="center" justifyContent="center" spacing={1} mb={2}>
        <Typography variant="subtitle2" flex="1 1 10%">Nazwa kontrolera</Typography>
        <SmallFormTextField
          sx={{ flex: '1 1 90%' }}
          name="name"
          id="name"
          type="text"
          placeholder="nazwa kontrolera"
          value={formik.values.name}
          onChange={formik.handleChange}
          error={formik.touched.name && Boolean(formik.errors.name)}
          helperText={formik.touched.name && formik.errors.name}
          autoFocus
        />
      </Stack>
      <Stack direction="row" alignItems="center" justifyContent="center" spacing={1} mb={2}>
        <Typography variant="subtitle2" flex="1 1 10%">Ośrodek</Typography>
        <SmallFormTextField
          sx={{ flex: '1 1 90%' }}
          select
          id="resort"
          name="resort"
          options={allResorts}
          value={formik.values.resort}
          onChange={formik.handleChange}
          error={formik.touched.resort && Boolean(formik.errors.resort)}
          helperText={formik.touched.resort && formik.errors.resort}
        />
      </Stack>
      {/* {formik.values.type ? <Stack direction="row" alignItems="center" justifyContent="center" spacing={1} mb={2}>
        <Typography variant="subtitle2" flex="1 1 10%">Turnus</Typography>
        <SmallFormTextField
          sx={{ flex: '1 1 90%' }}
          select
          id="resort"
          name="resort"
          options={!availableCampsError && !availableCampsLoading && availableCampsPayload ? availableCampsPayload : []}
          value={formik.values.resort}
          onChange={e => {
            formik.handleChange(e);
            formik.setFieldValue('transports', []);
          }}
        />
      </Stack> : null} */}
      <Stack direction="row" alignItems="center" justifyContent="center" spacing={1} mb={2}>
        <Typography variant="subtitle2" flex="1 1 10%">Typ</Typography>
        <SmallFormTextField
          sx={{ flex: '1 1 90%' }}
          select
          id="type"
          name="type"
          options={[{ value: 'Powrót', label: 'Powrót' }, { value: 'Wyjazd', label: 'Wyjazd' }]}
          value={formik.values.type}
          onChange={e => {
            formik.handleChange(e);
            formik.setFieldValue('transports', []);
          }}
        />
      </Stack>
      {formik.values.type ? <Stack direction="row" alignItems="center" justifyContent="center" spacing={1} mb={2}>
        <Typography variant="subtitle2" flex="1 1 10%">Turnus</Typography>
        <SmallFormTextField
          sx={{ flex: '1 1 90%' }}
          select
          id="camp"
          name="camp"
          options={!availableCampsError && !availableCampsLoading && availableCampsPayload ? availableCampsPayload : []}
          value={formik.values.camp}
          onChange={e => {
            formik.handleChange(e);
            formik.setFieldValue('transports', []);
          }}
        />
      </Stack> : null}
      {formik.values.camp ? <Stack direction="row" alignItems="center" justifyContent="center" spacing={1} mb={2}>
        <Typography variant="subtitle2" flex="1 1 10%">Transporty</Typography>
        <SmallFormTextField
          sx={{ flex: '1 1 90%' }}
          select
          multiple
          id="transports"
          name="transports"
          options={!availableTransportsError && !availableTransportsLoading && availableTransportsPayload ? availableTransportsPayload : []}
          value={formik.values.transports}
          onChange={formik.handleChange}
        />
      </Stack> : null}
      <Stack direction="row" alignItems="center" justifyContent="center" spacing={1} mb={2}>
        <Typography variant="subtitle2" flex="1 1 10%">Liczba miejsc</Typography>
        <SmallFormTextField
          sx={{ flex: '1 1 90%' }}
          id="seats"
          name="seats"
          type="number"
          value={formik.values.seats}
          onChange={e => formik.setFieldValue('seats', e.target.value.replace(/\D/g, ''))}
        />
      </Stack>
      {data ? <>
        <Stack direction="row" alignItems="center" justifyContent="center" spacing={1} mb={2}>
          <Typography variant="subtitle2" flex="1 1 10%">Zajęte miejsca</Typography>
          <SmallFormTextField
            sx={{ flex: '1 1 90%' }}
            type="number"
            value={data.taken_seats}
            disabled
          />
        </Stack>
        <Stack direction="row" alignItems="center" justifyContent="center" spacing={1} mb={2}>
          <Typography variant="subtitle2" flex="1 1 10%">Dostępne miejsca</Typography>
          <SmallFormTextField
            sx={{ flex: '1 1 90%' }}
            value={data.available_seats}
            type="number"
            disabled
          />
        </Stack>
      </> : null}
      <Button
        color="primary"
        variant="contained"
        type="submit"
        sx={{ mt: 3 }}
        disabled={loading}
      >
        <AddIcon />
          Zapisz
      </Button>
      { data
        ? <Button
          color="error"
          variant="contained"
          sx={{ mt: 3, ml: 4 }}
          onClick={() => {
            setConfirmDeleteOpen(true);
          }}
        >
          <DeleteIcon />
          Usuń
        </Button>
        : null}
    </form>
    <ConfirmDialog
      title="Usunąć transport?"
      open={confirmDeleteOpen}
      setOpen={setConfirmDeleteOpen}
      onConfirm={handleDelete}
      disabled={loading}
    >
        Czy na pewno chcesz usunąć ten transport?
    </ConfirmDialog>
  </>;
};
